import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await register(name, email, password);
    setBusy(false);
    if (res.ok) nav("/account");
    else setError(res.error);
  };

  const inputCls = "w-full border-2 border-border px-4 py-3 font-mono text-sm focus:outline-none focus:border-primary";

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24" data-testid="register-page">
      <h1 className="font-anton text-5xl uppercase tracking-tighter mb-2">Join Up</h1>
      <p className="font-mono text-sm text-muted-foreground mb-8">Create an account to track your orders.</p>
      {error && <p className="border-2 border-primary bg-primary/10 text-primary font-mono text-xs p-3 mb-5" data-testid="register-error">{error}</p>}
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="NAME" data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
        <input type="email" required placeholder="EMAIL" data-testid="register-email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        <input type="password" required placeholder="PASSWORD" data-testid="register-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
        <button type="submit" disabled={busy} data-testid="register-submit" className="w-full bg-primary text-primary-foreground font-outfit font-bold uppercase tracking-widest text-sm py-4 border-2 border-border hover:bg-secondary hover:border-secondary hover:text-white transition-colors disabled:opacity-50">
          {busy ? "Creating..." : "Create Account"}
        </button>
      </form>
      <p className="font-mono text-sm mt-6">
        Already in? <Link to="/login" data-testid="go-login" className="text-primary font-bold underline">Sign in</Link>
      </p>
    </div>
  );
}
